import api from '../../apiConfig/apiConfig';
import { Get, Put } from '../base/baseAjax';

let getDetail = async (param) => {
  return Get({
    url: api.evaluate.getDetail,
    UrlParam: param,
  });
};

let getInfo = async (param) => {
  return Put({
    url: api.evaluate.getInfo,
    UrlParam: param,
  });
};
let getUpdata = async (body, url) => {
  return Put({
    url: api.evaluate.getUpdata,
    bodyParam: body,
    UrlParam: url,
  });
};

let getDictionary = async (param) => {
  return Get({
    url: api.evaluate.getDictionaryApi,
    UrlParam: param,
  });
};

export default {
  getDetail: getDetail,
  getInfo: getInfo,
  getUpdata: getUpdata,
  getDictionary,
};
